<template>
  <div>
    <Breadcrumb msg1="预约分诊" msg2="分诊管理" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="5"><el-date-picker v-model="query.visit_date" type="date" value-format="yyyy-MM-dd" placeholder="就诊日期"></el-date-picker></el-col>
        <el-col :span="4">
          <el-select v-model="query.status" placeholder="状态" clearable>
            <el-option label="待接诊" value="待接诊"></el-option>
            <el-option label="接诊中" value="接诊中"></el-option>
            <el-option label="已完成" value="已完成"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="add">新增分诊</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="客户" width="100"><template slot-scope="scope">{{ customerName(scope.row.customerId) }}</template></el-table-column>
        <el-table-column label="就诊日期" prop="visitDate" width="110"></el-table-column>
        <el-table-column label="到店时间" prop="arriveTime" width="150"></el-table-column>
        <el-table-column label="科室" width="100"><template slot-scope="scope">{{ deptName(scope.row.departmentId) }}</template></el-table-column>
        <el-table-column label="医生" width="100"><template slot-scope="scope">{{ doctorNameOf(scope.row.doctorId) }}</template></el-table-column>
        <el-table-column label="优先级" prop="priority" width="80"></el-table-column>
        <el-table-column label="症状" prop="symptom" show-overflow-tooltip></el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '已完成' ? 'success' : (scope.row.status === '接诊中' ? 'primary' : 'warning')">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="260">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="changeStatus(scope.row)">状态流转</el-button>
            <el-button size="mini" type="success" @click="edit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="show" width="600px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px" v-if="show">
        <el-form-item label="客户" required>
          <el-select v-model="form.customer_id" filterable remote placeholder="输入姓名/手机号搜索" :remote-method="searchCustomer" style="width: 100%">
            <el-option v-for="c in customerOptions" :key="c.id" :label="c.name + ' ' + c.phone" :value="c.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="就诊日期"><el-date-picker v-model="form.visit_date" type="date" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker></el-form-item>
        <el-form-item label="到店时间"><el-date-picker v-model="form.arrive_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%"></el-date-picker></el-form-item>
        <el-form-item label="科室">
          <el-select v-model="form.department_id" style="width: 100%">
            <el-option v-for="d in departments" :key="d.id" :label="d.name" :value="d.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="医生">
          <el-select v-model="form.doctor_id" style="width: 100%">
            <el-option v-for="doc in doctors" :key="doc.id" :label="doc.realname" :value="doc.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="优先级">
          <el-select v-model="form.priority" style="width: 100%">
            <el-option label="普通" value="普通"></el-option>
            <el-option label="紧急" value="紧急"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="症状"><el-input v-model="form.symptom" type="textarea"></el-input></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="状态流转" :visible.sync="statusShow" width="400px">
      <el-select v-model="statusValue" style="width: 100%">
        <el-option label="待接诊" value="待接诊"></el-option>
        <el-option label="接诊中" value="接诊中"></el-option>
        <el-option label="已完成" value="已完成"></el-option>
      </el-select>
      <span slot="footer">
        <el-button @click="statusShow = false">取消</el-button>
        <el-button type="primary" @click="submitStatus">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import { loadCustomerMap, customerName } from '@/utils/customerName'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, visit_date: '', status: '' },
      list: [],
      total: 0,
      show: false,
      dialogTitle: '',
      form: {},
      statusShow: false,
      statusValue: '',
      statusRow: null,
      customerOptions: [],
      departments: [],
      doctors: []
    }
  },
  created () {
    this.getData()
    loadCustomerMap(this.$axios.http)
    this.$axios.http.get('/departments').then(r => { if (r.data.status === 200) this.departments = r.data.data || [] })
    this.$axios.http.get('/users/doctors').then(r => { if (r.data.status === 200) this.doctors = r.data.data || [] })
  },
  methods: {
    customerName,
    deptName (id) { const d = this.departments.find(x => x.id === id); return d ? d.name : '' },
    doctorNameOf (id) { const d = this.doctors.find(x => x.id === id); return d ? d.realname : '' },
    getData () {
      this.$axios.get('/triages', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    searchCustomer (kw) {
      if (!kw) return
      this.$axios.http.get('/customers/select', { params: { keyword: kw } }).then(r => {
        if (r.data.status === 200) this.customerOptions = r.data.data || []
      })
    },
    add () {
      this.dialogTitle = '新增分诊'
      this.form = { customer_id: null, visit_date: '', arrive_time: '', department_id: null, doctor_id: null, priority: '普通', symptom: '', nurse_id: null }
      this.show = true
    },
    edit (row) {
      this.dialogTitle = '编辑分诊'
      this.form = Object.assign({}, row, {
        customer_id: row.customerId,
        visit_date: row.visitDate,
        arrive_time: row.arriveTime,
        department_id: row.departmentId,
        doctor_id: row.doctorId
      })
      this.customerOptions = [{ id: row.customerId, name: customerName(row.customerId), phone: '' }]
      this.show = true
    },
    save () {
      if (!this.form.customer_id) { this.$message.warning('请选择客户'); return }
      if (this.form.id) {
        this.$axios.put(`/triages/${this.form.id}`, () => { this.show = false; this.getData() }, this.form)
      } else {
        this.$axios.post('/triages', () => { this.show = false; this.getData() }, this.form)
      }
    },
    changeStatus (row) {
      this.statusRow = row
      this.statusValue = row.status
      this.statusShow = true
    },
    submitStatus () {
      this.$axios.put(`/triages/${this.statusRow.id}/status`, () => { this.statusShow = false; this.getData() }, { status: this.statusValue })
    }
  }
}
</script>
